import { ServiceStoreConfig } from "./types/ServiceStoreTypes";

// ⚠ SIX FILES IN ./serviceStores ARE NEVER IMPORTED HERE and are therefore DEAD
// CONFIGURATION — nothing in them reaches the runtime:
//   engineering, equipment, logistics, materials, miller-mize, quality
// (~30 registrations). Editing one looks like it works and changes nothing;
// that has already cost a cycle (a 2026-07-27 fix to `storage-racks` in
// logistics.stores.ts was a silent no-op). Check the import list below before
// touching a *.stores.ts file, and note that the Miller-Mize stores talk to
// Feathers directly through `rootStore.app.service(...)` rather than through
// any ServiceStore — see the header of serviceStores/miller-mize.stores.ts.

// Import categorized service stores
import { aiStores } from "./serviceStores/ai.stores";
import { castStoneStores } from "./serviceStores/cast-stone.stores";
import { communicationStores } from "./serviceStores/communication.stores";
import { crmStores } from "./serviceStores/crm.stores";
import { departmentStores } from "./serviceStores/department.stores";
import { dispatchStores } from "./serviceStores/dispatch.stores";
import { fieldStores } from "./serviceStores/field.stores";
import { financialStores } from "./serviceStores/financial.stores";
import { hardwareStores } from "./serviceStores/hardware.stores";
import { jobStores } from "./serviceStores/job.stores";
import { manufacturingStores } from "./serviceStores/manufacturing.stores";
import { projectStores } from "./serviceStores/project.stores";
import { organizationDataStores } from "./serviceStores/organization-data.stores";
import { panelsStores } from "./serviceStores/panels.stores";
import { pdfEditorStores } from "./serviceStores/pdf-editor.stores";
import { schedulingStores } from "./serviceStores/scheduling.stores";
import { systemStores } from "./serviceStores/system.stores";
import { userStores } from "./serviceStores/user.stores";
import { yardStores } from "./serviceStores/yard.stores";
import { uncategorizedStores } from "./serviceStores/uncategorized.stores";

/**
 * Main Service Store Configuration
 * Combines all categorized service stores into a single array
 *
 * Categories are organized based on the api-types directory structure:
 * - AI: AI services (OpenAI, etc.)
 * - Communication: Chat, support tickets, RFI, submittals
 * - CRM: Accounts, contacts, opportunities, orders
 * - Department: Organization structure
 * - Dispatch: Load and trailer management
 * - Field: Field operations, issues, warranty claims
 * - Financial: Invoicing, billing, change orders, PO approvals
 * - Hardware: Hardware orders and details
 * - Job: Project and job management
 * - Manufacturing: BOM, materials, products, QC, NCR
 * - Organization Data: List tracker
 * - Panels: Panel production, additional casting, remediation
 * - PDF Editor: Document management
 * - Scheduling: Schedule generation, holidays
 * - System: API services, Azure blob storage
 * - User: User management, certifications, training
 * - Yard: Yard inventory and management
 * - Uncategorized: Services without api-types yet
 */
const serviceStores: ServiceStoreConfig[] = [
  // AI Services
  ...aiStores,

  // Cast Stone Services (@intrasync/cast-stone)
  ...castStoneStores,

  // Communication Services
  ...communicationStores,

  // CRM Services
  ...crmStores,

  // Department Services
  ...departmentStores,

  // Dispatch Services
  ...dispatchStores,

  // Field Services
  ...fieldStores,

  // Financial Services
  ...financialStores,

  // Hardware Services
  ...hardwareStores,

  // Job Services
  ...jobStores,

  // Project Services
  ...projectStores,

  // Manufacturing Services
  ...manufacturingStores,

  // Organization Data Services
  ...organizationDataStores,

  // Panel Services
  ...panelsStores,

  // PDF Editor Services
  ...pdfEditorStores,

  // Scheduling Services
  ...schedulingStores,

  // System Services
  ...systemStores,

  // User Services
  ...userStores,

  // Yard Services
  ...yardStores,

  // Uncategorized Services (no api-types directory yet)
  ...uncategorizedStores,
];

export default serviceStores;